import { useState } from 'react'
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, updateDoc, getDoc } from "firebase/firestore";
import { db } from '../firebase.config';
import shuffleArray from '../utils/shuffleArray';

function useAuth() {
  console.log('useAuth')
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [userDetails, setUserDetails] = useState(null)
  const auth = getAuth();
  onAuthStateChanged(auth, async (user) => {
    console.log('onAuthStateChanged')
    if (user) { 
      try {
      const userData = {}
      userData.displayName = user.displayName
      const userRef = doc(db, "users", auth.currentUser.uid);
      const userSnap = await getDoc(userRef);
      const { wordsPerPractice } = userSnap.data();
      userData.wordsPerPractice = wordsPerPractice;
      const wordListRef = doc(db, "privateWordLists", auth.currentUser.uid);
      const wordListSnap = await getDoc(wordListRef);
      const { wordList } = wordListSnap.data()
      shuffleArray(wordList)
      userData.wordList = wordList;
      if (!userDetails) { setUserDetails(userData) }
      setIsLoggedIn(true) 
    } catch(err) {
      console.log(err)
    }
    } 
    setIsLoading(false)
  });
  return { isLoggedIn, isLoading, userDetails }
}

export default useAuth
